import { FaIcon } from '@/lib/fa'
import { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import * as React from 'react'

type Props = {
  titleIcon?: IconDefinition
  title: string
  actions?: {
    icon: IconDefinition
    title: string
    onClick: () => void
  }[]
  children?: React.ReactNode
  middle?: React.ReactNode
}

export const ContentHeaderBar = ({
  titleIcon,
  title,
  actions,
  children,
  middle,
}: Props) => {
  return (
    <div className="tw-flex tw-items-center tw-justify-between tw-border-b tw-p-4 tw-bg-content-background">
      <div className='tw-flex tw-gap-2'>
        <div className="tw-flex tw-items-center tw-gap-2">
          {titleIcon && (
            <FaIcon icon={titleIcon} className="tw-text-lg" />
          )}
          <h2 className="tw-text-lg tw-mb-0 tw-font-semibold">{title}</h2>
        </div>
        {actions && (
          <div className="tw-flex tw-gap-2">
            {actions.map((action, index) => (
              <button
                key={index}
                onClick={action.onClick}
                className="tw-flex tw-items-center tw-gap-1"
                title={action.title}
              >
                <FaIcon icon={action.icon} className="tw-text-sm" />
              </button>
            ))}
          </div>
        )}
      </div>
      {middle && (
        <div className='tw-flex tw-gap-4'>
          {middle}
        </div>
      )}
      <div className='tw-flex tw-gap-4 tw-justify-end tw-items-center'>
        {children}
      </div>
    </div>
  )
}
